module.exports = __webpack_public_path__ + "img/UG.b3ce95f6.svg";